
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ConfigUpdateType enum
 */
class ConfigUpdateType {
  /**
   * Initialize enum with a given value
   * @param {ConfigUpdateType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ConfigUpdateType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ConfigUpdateType}
   * @param {!ConfigUpdateType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ConfigUpdateType)) {
      throw new TypeError('Instance of ConfigUpdateType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ConfigUpdateType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ConfigUpdateType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ConfigUpdateType.CREATE.value) {
      return 'CREATE'
    }
    if (this.value === ConfigUpdateType.UPDATE.value) {
      return 'UPDATE'
    }
    if (this.value === ConfigUpdateType.DELETE.value) {
      return 'DELETE'
    }
    if (this.value === ConfigUpdateType.UPDATE_PARTIALLY.value) {
      return 'UPDATE_PARTIALLY'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ConfigUpdateType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ConfigUpdateType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ConfigUpdateType} Created enum
   */
  static fromObject (other) {
    return new ConfigUpdateType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ConfigUpdateType.CREATE = new ConfigUpdateType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ConfigUpdateType.UPDATE = new ConfigUpdateType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ConfigUpdateType.DELETE = new ConfigUpdateType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ConfigUpdateType.UPDATE_PARTIALLY = new ConfigUpdateType(0 + 3)

export { ConfigUpdateType };

/**
 * Fast Binary Encoding ConfigUpdateType field model
 */
class FieldModelConfigUpdateType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelConfigUpdateType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelConfigUpdateType}
   * @param {ConfigUpdateType=} defaults Default value, defaults is new ConfigUpdateType()
   * @returns {!ConfigUpdateType} Result value
   */
  get (defaults = new ConfigUpdateType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ConfigUpdateType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelConfigUpdateType}
   * @param {!ConfigUpdateType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelConfigUpdateType };
